/**
 * @generated SignedSource<<b234a82c1b4155ac26e37b7d8c5cb8ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TrackBlogPostViewInput = {
  blogPostId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type BlogPost_TrackViewMutation$variables = {
  input: TrackBlogPostViewInput;
};
export type BlogPost_TrackViewMutation$data = {
  readonly trackBlogPostView: {
    readonly blogPost: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type BlogPost_TrackViewMutation = {
  response: BlogPost_TrackViewMutation$data;
  variables: BlogPost_TrackViewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TrackBlogPostViewPayload",
    "kind": "LinkedField",
    "name": "trackBlogPostView",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BlogPost",
        "kind": "LinkedField",
        "name": "blogPost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogPost_TrackViewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlogPost_TrackViewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "21a03e237cd9cb1cf0b2c5b7115345b8",
    "id": null,
    "metadata": {},
    "name": "BlogPost_TrackViewMutation",
    "operationKind": "mutation",
    "text": "mutation BlogPost_TrackViewMutation(\n  $input: TrackBlogPostViewInput!\n) {\n  trackBlogPostView(input: $input) {\n    blogPost {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c78abe84de6eed0e387ddefcd9d59259";

export default node;
